import { Client, AccountConfig } from '../types';

/**
 * Resuelve la lista efectiva de cuentas de un cliente.
 * Compatibilidad: si no hay `accounts[]` pero existe el `roleArn` legacy de nivel
 * superior, lo envuelve como una sola cuenta.
 */
export function resolveClientAccounts(client: Client): AccountConfig[] {
  if (client.accounts && client.accounts.length > 0) return client.accounts;
  if (client.roleArn) {
    return [{ label: 'Principal', roleArn: client.roleArn, region: client.region || 'us-east-1' }];
  }
  return [];
}

/** Una cuenta "carece de rol" cuando su roleArn está vacío o solo tiene espacios. */
export function accountHasRole(account: AccountConfig): boolean {
  return !!account.roleArn && account.roleArn.trim().length > 0;
}

/** Devuelve las cuentas del cliente que NO tienen un rol configurado. */
export function getAccountsMissingRole(client: Client): AccountConfig[] {
  return resolveClientAccounts(client).filter((a) => !accountHasRole(a));
}

/** Número de cuentas del cliente sin rol configurado. */
export function countAccountsMissingRole(client: Client): number {
  return getAccountsMissingRole(client).length;
}
